module.exports = __webpack_public_path__ + "static/3_2_Bayes-Rule_2_FR-18c2c6681d42c992f2d56028d6d1f0f0.svg";